import React, { Component } from "react";
import * as GoogleAnalytics from "./GoogleAnalyticsUtils";

export const withTracker = (WrappedComponent: React.ComponentType<any>, options = {}) => {
	const trackPage = (page: string) => {
		GoogleAnalytics.set({
			page,
			...options
		});
		GoogleAnalytics.pageview(page);
	};

	const HOC = class extends Component<any> {
		public componentDidMount() {
			const page = this.props.location.pathname;
			trackPage(page);
		}

		public componentWillReceiveProps(nextProps: any) {
			const currentPage = this.props.location.pathname;
			const nextPage = nextProps.location.pathname;

			if (currentPage !== nextPage) {
				trackPage(nextPage);
			}
		}

		public render() {
			return <WrappedComponent {...this.props} />;
		}
	};

	GoogleAnalytics.sendEvent({ category: "Startup", action: "App Started" });
	return HOC;
};

export default withTracker;
